import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getRecaptcha as recaptcha } from "../../libs/utils";

export const getRecaptcha = createAsyncThunk(
  "recaptcha/getRecaptcha",
  async (obj, { rejectWithValue }) => {
    try {
      const { action } = obj
      const response = await recaptcha(action);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const initialState = {
  data: null,
  error: null,
  status: null,
};

export const recaptchaSlice = createSlice({
  name: "recaptcha",
  initialState: initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getRecaptcha.pending, (state, action) => {
        return (state = { ...state, status: "loading" });
      })
      .addCase(getRecaptcha.fulfilled, (state, action) => {
        return (state = {
          ...state,
          status: "succeeded",
          data: action.payload,
          error: null,
        });
      })
      .addCase(getRecaptcha.rejected, (state, action) => {
        return (state = {
          ...state,
          status: "failed",
          error: action.payload,
          data: null,
        });
      });
  },
});

export default recaptchaSlice.reducer;
